import React, { useState } from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";

/* ===== Main Nav Links ===== */
export const NavLinks = styled(NavLink)`
  position: relative;
  color: #334155; /* Slate-700 */
  padding: 12px 20px;
  text-decoration: none;
  display: flex;
  align-items: center;
  margin: 4px 10px;
  border-radius: 10px;
  font-weight: 500;
  transition: all 0.25s ease;
  background: transparent;

  &:hover {
    background: linear-gradient(
      135deg,
      rgba(37, 99, 235, 0.08),
      rgba(59, 130, 246, 0.05)
    );
    transform: translateX(3px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  &.active {
    background: rgba(37, 99, 235, 0.15);
    color: #2563eb;
    font-weight: 600;
    border-left: 4px solid #3b82f6;
    padding-left: 16px;

    svg {
      color: #2563eb;
    }
  }
`;

/* ===== Icon Wrapper ===== */
const Icon = styled.div`
  margin-right: 14px;
  font-size: 20px;
  display: flex;
  align-items: center;
  color: #64748b; /* Slate-500 */

  svg {
    font-size: 1.25rem;
    transition: color 0.2s;
  }

  ${NavLinks}:hover & svg {
    color: #2563eb;
  }
`;

/* ===== Button for submenu parent ===== */
const NavBtn = styled.div`
  position: relative;
  color: #334155; /* Slate-700 */
  padding: 12px 20px;
  display: flex;
  align-items: center;
  margin: 4px 10px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.25s ease;
  background: ${(props) => props.open && "rgba(37, 99, 235, 0.15)"};

  &:hover {
    background: linear-gradient(
      135deg,
      rgba(37, 99, 235, 0.08),
      rgba(59, 130, 246, 0.05)
    );
    transform: translateX(3px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }
`;

/* ===== Arrow Icon for submenu ===== */
const Arrow = styled.div`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translate(0, -50%);

  > span {
    display: inline-block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px 0 5px 6px;
    border-color: transparent transparent transparent #94a3b8;
    transform: ${(props) => (props.open ? "rotate(90deg)" : "rotate(0deg)")};
    transition: all 0.2s ease;
  }
`;

/* ===== Submenu Wrapper ===== */
const SubMenu = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: rgba(241, 245, 249, 0.8); /* Slate-50 w/ translucency */
  backdrop-filter: blur(6px);
  overflow: hidden;
  height: ${(props) => (props.opened === "true" ? props.tall * 50 + 8 : 0)}px;
  transition: all 0.3s ease;
  padding: ${(props) => (props.opened === "true" ? "6px 0" : "0px")};
  margin: 0 0 4px;
  border-radius: 0 0 10px 10px;
`;

/* ===== Submenu Links ===== */
const SubLinks = styled(NavLink)`
  color: #475569; /* Slate-600 */
  padding: 8px 20px;
  height: 44px;
  text-decoration: none;
  display: flex;
  align-items: center;
  margin: 2px 12px;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.25s ease;
  font-size: 0.92rem;

  > span {
    margin-left: 14px;
  }

  &:hover {
    background: rgba(37, 99, 235, 0.08);
    transform: translateX(2px);
    color: #1e293b; /* Slate-800 */
  }

  &.active {
    background: rgba(37, 99, 235, 0.15);
    color: #2563eb;
    font-weight: 600;
    border-left: 3px solid #3b82f6;
    padding-left: 14px;

    svg {
      color: #2563eb;
    }
  }
`;

export { Icon, NavBtn, Arrow, SubMenu, SubLinks };

const SideBarBtns = ({ to, icon, title, subBtn, handleClick }) => {
  const [openSubMenu, setOpenSubMenu] = useState(false);

  const handleSubMenu = () => {
   if (Array.isArray(subBtn) && subBtn.length > 0) {
  setOpenSubMenu(!openSubMenu);
}
  };

  return (
    <li>
    {!subBtn || subBtn.length === 0 ? (
        <NavLinks strict="true" to={{ pathname: to }} onClick={handleClick}>
          <Icon>{icon}</Icon>
          {title}
        </NavLinks>
      ) : (
        <>
          <NavBtn onClick={handleSubMenu} open={openSubMenu}>
            <Icon>{icon}</Icon>
            {title}
            <Arrow open={openSubMenu}>
              <span></span>
            </Arrow>
          </NavBtn>
          <SubMenu
            tall={Array.isArray(subBtn) ? subBtn.length : 1}
            opened={openSubMenu ? "true" : "false"}
          >
            {Array.isArray(subBtn)
              ? subBtn.map((btn, i) => (
                <div key={i}>
                  <SubLinks to={btn.path} onClick={handleClick}>
                    {btn.icon && <Icon>{btn.icon}</Icon>}
                    <span>{btn.title}</span>
                  </SubLinks>
                </div>
              ))
              : subBtn && (
                <div>
                  <SubLinks to={subBtn.path} onClick={handleClick}>
                    {subBtn.icon && <Icon>{subBtn.icon}</Icon>}
                    <span>{subBtn.title}</span>
                  </SubLinks>
                </div>
              )}
          </SubMenu>
        </>
      )}
    </li>
  );
};

export default SideBarBtns;
